import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=aa4c9096&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4c9096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa4c9096')) {
      api.createRecord('aa4c9096', component.options)
    } else {
      api.reload('aa4c9096', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=aa4c9096&scoped=true&", function () {
      api.rerender('aa4c9096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zCDZhw8C4LOg/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports